var _a;
const apm = otto.apm;
const agent = apm.agent;
const getCurrentTransaction = apm.getCurrentTransaction;
const startSpan = apm.startSpan;
const captureError = apm.captureError;
const mark = apm.mark;
const addLabels = apm.addLabels;
const apmSync = ((_a = window.o_util) == null ? void 0 : _a.apm) ?? {};
const runWithSpan = apmSync.runWithSpan;
const withSpan = apmSync.withSpan;
export {
  addLabels,
  agent,
  apm,
  apmSync,
  captureError,
  getCurrentTransaction,
  mark,
  runWithSpan,
  startSpan,
  withSpan
};
/*                                   */
